import { TenantEntity } from '../TenantEntity'
import { cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { Job } from '@/class/model/booking/Job'

export class CargoDoc extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'CargoDoc'
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state || 0
  }
  get docType() {
    return this._data.docType
  }
  set docType(docType) {
    this._data.docType = docType
  }
  get hblNbr2() {
    return this._data.hblNbr2
  }
  set hblNbr2(hblNbr2) {
    this._data.hblNbr2 = hblNbr2
  }
  get shipperId() {
    return this._data.shipperId
  }
  set shipperId(shipperId) {
    this._data.shipperId = shipperId || 0
  }
  // 非db字段，是否删除此装箱信息，用于后端逻辑判断
  get deleted() {
    return this._data.deleted || false
  }
  set deleted(deleted) {
    this._data.deleted = deleted
  }
  get shipperCode() {
    return this._data.shipperCode
  }
  set shipperCode(shipperCode) {
    this._data.shipperCode = shipperCode
  }
  get shipperLine1() {
    return this._data.shipperLine1
  }
  set shipperLine1(shipperLine1) {
    this._data.shipperLine1 = shipperLine1
  }
  get shipperLine2() {
    return this._data.shipperLine2
  }
  set shipperLine2(shipperLine2) {
    this._data.shipperLine2 = shipperLine2
  }
  get shipperLine3() {
    return this._data.shipperLine3
  }
  set shipperLine3(shipperLine3) {
    this._data.shipperLine3 = shipperLine3
  }
  get shipperLine4() {
    return this._data.shipperLine4
  }
  set shipperLine4(shipperLine4) {
    this._data.shipperLine4 = shipperLine4
  }
  get shipperLine5() {
    return this._data.shipperLine5
  }
  set shipperLine5(shipperLine5) {
    this._data.shipperLine5 = shipperLine5
  }
  get shipperLine6() {
    return this._data.shipperLine6
  }
  set shipperLine6(shipperLine6) {
    this._data.shipperLine6 = shipperLine6
  }
  get shipperLine7() {
    return this._data.shipperLine7
  }
  set shipperLine7(shipperLine7) {
    this._data.shipperLine7 = shipperLine7
  }
  get consigneeId() {
    return this._data.consigneeId
  }
  set consigneeId(consigneeId) {
    this._data.consigneeId = consigneeId || 0
  }
  get consigneeCode() {
    return this._data.consigneeCode
  }
  set consigneeCode(consigneeCode) {
    this._data.consigneeCode = consigneeCode
  }
  get consigneeLine1() {
    return this._data.consigneeLine1
  }
  set consigneeLine1(consigneeLine1) {
    this._data.consigneeLine1 = consigneeLine1
  }
  get consigneeLine2() {
    return this._data.consigneeLine2
  }
  set consigneeLine2(consigneeLine2) {
    this._data.consigneeLine2 = consigneeLine2
  }
  get consigneeLine3() {
    return this._data.consigneeLine3
  }
  set consigneeLine3(consigneeLine3) {
    this._data.consigneeLine3 = consigneeLine3
  }
  get consigneeLine4() {
    return this._data.consigneeLine4
  }
  set consigneeLine4(consigneeLine4) {
    this._data.consigneeLine4 = consigneeLine4
  }
  get consigneeLine5() {
    return this._data.consigneeLine5
  }
  set consigneeLine5(consigneeLine5) {
    this._data.consigneeLine5 = consigneeLine5
  }
  get consigneeLine6() {
    return this._data.consigneeLine6
  }
  set consigneeLine6(consigneeLine6) {
    this._data.consigneeLine6 = consigneeLine6
  }
  get consigneeLine7() {
    return this._data.consigneeLine7
  }
  set consigneeLine7(consigneeLine7) {
    this._data.consigneeLine7 = consigneeLine7
  }
  get notifyId() {
    return this._data.notifyId
  }
  set notifyId(notifyId) {
    this._data.notifyId = notifyId || 0
  }
  get notifyCode() {
    return this._data.notifyCode
  }
  set notifyCode(notifyCode) {
    this._data.notifyCode = notifyCode
  }
  get notifyLine1() {
    return this._data.notifyLine1
  }
  set notifyLine1(notifyLine1) {
    this._data.notifyLine1 = notifyLine1
  }
  get notifyLine2() {
    return this._data.notifyLine2
  }
  set notifyLine2(notifyLine2) {
    this._data.notifyLine2 = notifyLine2
  }
  get notifyLine3() {
    return this._data.notifyLine3
  }
  set notifyLine3(notifyLine3) {
    this._data.notifyLine3 = notifyLine3
  }
  get notifyLine4() {
    return this._data.notifyLine4
  }
  set notifyLine4(notifyLine4) {
    this._data.notifyLine4 = notifyLine4
  }
  get notifyLine5() {
    return this._data.notifyLine5
  }
  set notifyLine5(notifyLine5) {
    this._data.notifyLine5 = notifyLine5
  }
  get notifyLine6() {
    return this._data.notifyLine6
  }
  set notifyLine6(notifyLine6) {
    this._data.notifyLine6 = notifyLine6
  }
  get notifyLine7() {
    return this._data.notifyLine7
  }
  set notifyLine7(notifyLine7) {
    this._data.notifyLine7 = notifyLine7
  }
  get agentCode() {
    return this._data.agentCode
  }
  set agentCode(agentCode) {
    this._data.agentCode = agentCode
  }
  get agentPartyLine1() {
    return this._data.agentPartyLine1
  }
  set agentPartyLine1(agentPartyLine1) {
    this._data.agentPartyLine1 = agentPartyLine1
  }
  get agentPartyLine2() {
    return this._data.agentPartyLine2
  }
  set agentPartyLine2(agentPartyLine2) {
    this._data.agentPartyLine2 = agentPartyLine2
  }
  get agentPartyLine3() {
    return this._data.agentPartyLine3
  }
  set agentPartyLine3(agentPartyLine3) {
    this._data.agentPartyLine3 = agentPartyLine3
  }
  get agentPartyLine4() {
    return this._data.agentPartyLine4
  }
  set agentPartyLine4(agentPartyLine4) {
    this._data.agentPartyLine4 = agentPartyLine4
  }
  get agentPartyLine5() {
    return this._data.agentPartyLine5
  }
  set agentPartyLine5(agentPartyLine5) {
    this._data.agentPartyLine5 = agentPartyLine5
  }
  get agentPartyLine6() {
    return this._data.agentPartyLine6
  }
  set agentPartyLine6(agentPartyLine6) {
    this._data.agentPartyLine6 = agentPartyLine6
  }
  get agentPartyLine7() {
    return this._data.agentPartyLine7
  }
  set agentPartyLine7(agentPartyLine7) {
    this._data.agentPartyLine7 = agentPartyLine7
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight || 0
  }
  get volumetricWeight() {
    return this._data.volumetricWeight
  }
  set volumetricWeight(volumetricWeight) {
    this._data.volumetricWeight = volumetricWeight || 0
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage || 0
  }
  get chargeWeight() {
    return this._data.chargeWeight
  }
  set chargeWeight(chargeWeight) {
    this._data.chargeWeight = chargeWeight || 0
  }
  get packing() {
    return this._data.packing
  }
  set packing(packing) {
    this._data.packing = packing
  }
  get cargoEnglishName() {
    return this._data.cargoEnglishName
  }
  set cargoEnglishName(cargoEnglishName) {
    this._data.cargoEnglishName = cargoEnglishName
  }
  get mark() {
    return this._data.mark
  }
  set mark(mark) {
    this._data.mark = mark
  }
  get blNumber() {
    return this._data.blNumber
  }
  set blNumber(blNumber) {
    this._data.blNumber = blNumber
  }
  get blCopyNumber() {
    return this._data.blCopyNumber
  }
  set blCopyNumber(blCopyNumber) {
    this._data.blCopyNumber = blCopyNumber
  }
  get signDateBL() {
    return this._data.signDateBL
  }
  set signDateBL(signDateBL) {
    this._data.signDateBL = signDateBL
  }
  get signPlaceBL() {
    return this._data.signPlaceBL
  }
  set signPlaceBL(signPlaceBL) {
    this._data.signPlaceBL = signPlaceBL
  }
  get signDateBy() {
    return this._data.signDateBy
  }
  set signDateBy(signDateBy) {
    this._data.signDateBy = signDateBy || 0
  }
  get releaseType() {
    return this._data.releaseType
  }
  set releaseType(releaseType) {
    this._data.releaseType = releaseType || 0
  }
  get issuerBL() {
    return this._data.issuerBL
  }
  set issuerBL(issuerBL) {
    this._data.issuerBL = issuerBL
  }
  get oversea() {
    return this._data.oversea
  }
  set oversea(oversea) {
    this._data.oversea = oversea || false
  }
  get insideQuantity() {
    return this._data.insideQuantity
  }
  set insideQuantity(insideQuantity) {
    this._data.insideQuantity = insideQuantity || 0
  }
  get insidePacking() {
    return this._data.insidePacking
  }
  set insidePacking(insidePacking) {
    this._data.insidePacking = insidePacking
  }
  get paymentTerm() {
    return this._data.paymentTerm
  }
  set paymentTerm(paymentTerm) {
    this._data.paymentTerm = paymentTerm
  }
  get cfmState() {
    return this._data.cfmState
  }
  set cfmState(cfmState) {
    this._data.cfmState = cfmState || 0
  }
  get freightChargeTotal() {
    return this._data.freightChargeTotal
  }
  set freightChargeTotal(freightChargeTotal) {
    this._data.freightChargeTotal = freightChargeTotal || 0
  }
  get freightChargeEnUpper() {
    return this._data.freightChargeEnUpper
  }
  set freightChargeEnUpper(freightChargeEnUpper) {
    this._data.freightChargeEnUpper = freightChargeEnUpper
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  // Packing Name
  get packingName() {
    return this._data.packingName
  }
  set packingName(packingName) {
    this._data.packingName = packingName
  }
  // 主单号
  get mbl() {
    return this._data.mbl
  }
  set mbl(mbl) {
    this._data.mbl = mbl
  }
  // ETD
  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }
  // ETA
  get eta() {
    return this._data.eta
  }
  set eta(eta) {
    this._data.eta = eta
  }
  // 海关编码
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  // 原产国
  get countryOrigin() {
    return this._data.countryOrigin
  }
  set countryOrigin(countryOrigin) {
    this._data.countryOrigin = countryOrigin
  }
  // 客户类型
  get customerType() {
    return this._data.customerType
  }
  set customerType(customerType) {
    this._data.customerType = customerType
  }
  // HTS号码
  get htsCode() {
    return this._data.htsCode
  }
  set htsCode(htsCode) {
    this._data.htsCode = htsCode
  }
  // 提单签发状态,0-未签发、1-已签发、2-已取回、3-已接收、4-已认领、5-改单中
  get bliStatus() {
    return this._data.bliStatus
  }
  set bliStatus(bliStatus) {
    this._data.bliStatus = bliStatus
  }
  get containerStatus() {
    return this._data.containerStatus
  }
  set containerStatus(containerStatus) {
    this._data.containerStatus = containerStatus
  }
  get docCargoType() {
    return this._data.docCargoType
  }
  set docCargoType(docCargoType) {
    this._data.docCargoType = docCargoType
  }
  get undgNumber() {
    return this._data.undgNumber
  }
  set undgNumber(undgNumber) {
    this._data.undgNumber = undgNumber
  }
  get imoClass() {
    return this._data.imoClass
  }
  set imoClass(imoClass) {
    this._data.imoClass = imoClass
  }
  get berthDate() {
    return this._data.berthDate
  }
  set berthDate(berthDate) {
    this._data.berthDate = berthDate
  }
  get shedNumber() {
    return this._data.shedNumber
  }
  set shedNumber(shedNumber) {
    this._data.shedNumber = shedNumber
  }
  get shipAgent() {
    return this._data.shipAgent
  }
  set shipAgent(shipAgent) {
    this._data.shipAgent = shipAgent || 0
  }
  get shipAgentTaxNo() {
    return this._data.shipAgentTaxNo
  }
  set shipAgentTaxNo(shipAgentTaxNo) {
    this._data.shipAgentTaxNo = shipAgentTaxNo
  }
  get modificationCount() {
    return this._data.modificationCount
  }
  set modificationCount(modificationCount) {
    this._data.modificationCount = modificationCount
  }
  get cargoMovement() {
    return this._data.cargoMovement
  }
  set cargoMovement(cargoMovement) {
    this._data.cargoMovement = cargoMovement
  }
  get hblRefNo() {
    return this._data.hblRefNo
  }
  set hblRefNo(hblRefNo) {
    this._data.hblRefNo = hblRefNo
  }
  get portRequirement() {
    return this._data.portRequirement
  }
  set portRequirement(portRequirement) {
    this._data.portRequirement = portRequirement
  }
  get regionWarehouseMappingUuid() {
    return this._data.regionWarehouseMappingUuid
  }
  set regionWarehouseMappingUuid(regionWarehouseMappingUuid) {
    this._data.regionWarehouseMappingUuid = regionWarehouseMappingUuid
  }
  get allowRelease() {
    return this._data.allowRelease
  }
  set allowRelease(allowRelease) {
    this._data.allowRelease = allowRelease
  }
  get job() {
    return this._data.job
  }
  set job(job) {
    this._data.job = job
  }
  // 业务类型
  get businessLob() {
    return this._data.businessLob
  }
  set businessLob(businessLob) {
    this._data.businessLob = businessLob
  }
  // copy属性
  copyBasic(source) {
    this.docType = source.docType
    this.agentCode = source.agentCode
    this.agentPartyLine1 = source.agentPartyLine1
    this.agentPartyLine2 = source.agentPartyLine2
    this.agentPartyLine3 = source.agentPartyLine3
    this.agentPartyLine4 = source.agentPartyLine4
    this.agentPartyLine5 = source.agentPartyLine5
    this.agentPartyLine6 = source.agentPartyLine6
    this.agentPartyLine7 = source.agentPartyLine7
    this.cargoEnglishName = source.cargoEnglishName
    this.copyBasicConsignee(source)
    this.copyBasicNotify(source)
    this.cubage = source.cubage
    this.insidePacking = source.insidePacking
    this.insideQuantity = source.insideQuantity
    this.oversea = source.oversea
    this.issuerBL = source.issuerBL
    this.mark = source.mark
    this.packing = source.packing
    this.quantity = source.quantity
    this.releaseType = source.releaseType
    this.copyBasicShipper(source)
    this.signDateBy = source.signDateBy
    this.signPlaceBL = source.signPlaceBL
    this.weight = source.weight
    if (cache.config) {
      const synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(cache.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode'))
      if (synchronousShipperCodeAndConsigneeCodeAndNotifyCode === 1) {
        this.shipperId = source.shipperId
        this.consigneeId = source.consigneeId
        this.notifyId = source.notifyId
      }
    }
  }
  /**
 * 收货人
 */
  copyBasicConsignee(source, ignoreEmpty = false, syncCustomerShippingInfoBothBolAndBasicTab = false) {
    if (!StrUtils.isEmpty(source.consigneeLine1) ||
        !StrUtils.isEmpty(source.consigneeLine2) ||
        !StrUtils.isEmpty(source.consigneeLine3) ||
        !StrUtils.isEmpty(source.consigneeLine4) ||
        !StrUtils.isEmpty(source.consigneeLine5) ||
        !StrUtils.isEmpty(source.consigneeLine6) ||
        !StrUtils.isEmpty(source.consigneeLine7) || ignoreEmpty || syncCustomerShippingInfoBothBolAndBasicTab) {
      this.consigneeCode = source.consigneeCode
      this.consigneeLine1 = source.consigneeLine1
      this.consigneeLine2 = source.consigneeLine2
      this.consigneeLine3 = source.consigneeLine3
      this.consigneeLine4 = source.consigneeLine4
      this.consigneeLine5 = source.consigneeLine5
      this.consigneeLine6 = source.consigneeLine6
      this.consigneeLine7 = source.consigneeLine7
    }
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.consigneeId = source.consigneeId
    }
  }
  /**
   * 发货人
   */
  copyBasicShipper(source, ignoreEmpty = false, syncCustomerShippingInfoBothBolAndBasicTab = false) {
    if (!StrUtils.isEmpty(source.shipperLine1) ||
        !StrUtils.isEmpty(source.shipperLine2) ||
        !StrUtils.isEmpty(source.shipperLine3) ||
        !StrUtils.isEmpty(source.shipperLine4) ||
        !StrUtils.isEmpty(source.shipperLine5) ||
        !StrUtils.isEmpty(source.shipperLine6) ||
        !StrUtils.isEmpty(source.shipperLine7) || ignoreEmpty || syncCustomerShippingInfoBothBolAndBasicTab) {
      this.shipperCode = source.shipperCode
      this.shipperLine1 = source.shipperLine1
      this.shipperLine2 = source.shipperLine2
      this.shipperLine3 = source.shipperLine3
      this.shipperLine4 = source.shipperLine4
      this.shipperLine5 = source.shipperLine5
      this.shipperLine6 = source.shipperLine6
      this.shipperLine7 = source.shipperLine7
    }
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.shipperId = source.shipperId
    }
  }
  /**
   * 通知人
   */
  copyBasicNotify(source, ignoreEmpty = false, syncCustomerShippingInfoBothBolAndBasicTab = false) {
    if (!StrUtils.isEmpty(source.notifyLine1) ||
        !StrUtils.isEmpty(source.notifyLine2) ||
        !StrUtils.isEmpty(source.notifyLine3) ||
        !StrUtils.isEmpty(source.notifyLine4) ||
        !StrUtils.isEmpty(source.notifyLine5) ||
        !StrUtils.isEmpty(source.notifyLine6) ||
        !StrUtils.isEmpty(source.notifyLine7) || ignoreEmpty || syncCustomerShippingInfoBothBolAndBasicTab) {
      this.notifyCode = source.notifyCode
      this.notifyLine1 = source.notifyLine1
      this.notifyLine2 = source.notifyLine2
      this.notifyLine3 = source.notifyLine3
      this.notifyLine4 = source.notifyLine4
      this.notifyLine5 = source.notifyLine5
      this.notifyLine6 = source.notifyLine6
      this.notifyLine7 = source.notifyLine7
    }
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.notifyId = source.notifyId
    }
  }
  copyBasicAlsoNotify(source, ignoreEmpty = false, syncCustomerShippingInfoBothBolAndBasicTab = false) {
    if (!StrUtils.isEmpty(source.alsoNotify) || ignoreEmpty || syncCustomerShippingInfoBothBolAndBasicTab) {
      this.alsoNotify = source.alsoNotify
    }
  }

  syncDocSftToJob(job, ignoreEmpty, syncCustomerShippingInfoBothBolAndBasicTab) {
    new Job(job).copyBasicShipper(this, ignoreEmpty, syncCustomerShippingInfoBothBolAndBasicTab)
    new Job(job).copyBasicConsignee(this, ignoreEmpty, syncCustomerShippingInfoBothBolAndBasicTab)
    new Job(job).copyBasicNotify(this, ignoreEmpty, syncCustomerShippingInfoBothBolAndBasicTab)
  }
}
